import { NavigationGuard } from "vue-router";
import { firstBootStore } from "@/store/first-boot";

/**
 * アプリ起動時に案件一覧画面に遷移する
 * @param to
 * @param _from
 * @param next
 */
export const startRedirect: NavigationGuard = (to, _from, next) => {
  // 対象ページがチェック
  if (to.meta?.isStartPage) {
    // 初回起動かチェック
    if (firstBootStore.isFirstBoot) {
      next({
        name: "FirstBoot"
      });
      return;
    }

    next({
      name: "Search"
    });
    return;
  }
  next();
};
